import { isNil } from 'lodash';
import { AllEntityId } from 'modules/campaigns/config/allEntityId';
import { ENTITY } from 'modules/campaigns/config/routes/entity';
import { EXPLORATION_STATUS } from 'modules/campaigns/config/siteConsts';
import { BID_STRATEGIES, VIDEO_PRICING_MODEL } from 'modules/campaigns/modules/common-campaign-form/config';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isVideoCampaign } from 'services/campaignDimension';
import { isPerformanceRulesActiveOnAccountLevel, onlySelectedCampaignColumn } from './commonPredicates';

const isCampaignGroupSelected = id => !isNil(id) && id !== AllEntityId;

const isSiteBlockingDisabled = (data, selectedCampaignGroupId) =>
    !data.isBlockPublisherAllowed || isCampaignGroupSelected(selectedCampaignGroupId);

const isSiteStatusEditable = ({ data = {}, context }) => {
    const { userPermissions, selectedAccountConfig, selectedEntityIds, selectedEntityType } = context;
    const selectedCampaignGroupId = selectedEntityType === ENTITY.CAMPAIGNS_GROUP ? selectedEntityIds : AllEntityId;

    return (
        ((data.explorationStatus &&
            data.explorationStatus === EXPLORATION_STATUS.IN_PROGRESS &&
            userPermissions['EXPLORATION_BAR_AND_STATUS']) ||
            (data.publisherBlockingLevel === 'NONE' &&
                data.safetyNetsStatus &&
                userPermissions['SAFETY_NETS_VIEW'] &&
                isSpendGuardActiveOnAccountLevel(selectedAccountConfig)) ||
            (userPermissions['SPEND_GUARD_ACTION_DETAILS_VIEW'] &&
                data.isPublisherBlocked &&
                data.spendGuardsActionType) ||
            (isPerformanceRulesActiveOnAccountLevel(selectedAccountConfig) && !!data.performanceRuleId)) &&
        !isCampaignGroupSelected(selectedCampaignGroupId)
    );
};

const isTooltipDisabled = data => isSiteBlockingDisabled(data) && !isVideoCampaign(data.dimension);
const isBidStrategyPerAffiliateEditable = params =>
    params.data.bidStrategy !== BID_STRATEGIES.FIXED && params.data.bidStrategy !== BID_STRATEGIES.TARGET_CPA;

const isVideoAccountReport = data => isVideoCampaign(data.dimension);

const isSpendGuardActiveOnAccountLevel = selectedAccountConfig =>
    selectedAccountConfig?.[FEATURE_FLAGS.SAFETY_NETS_ENABLED_CONFIG_ATTRIBUTE] === 'true';

export const isCpcBasedBidStrategy = ({ selectedCampaign }) =>
    !isNil(selectedCampaign?.bidStrategy) &&
    selectedCampaign?.bidStrategy !== BID_STRATEGIES.MAX_CONVERSIONS &&
    selectedCampaign?.bidStrategy !== BID_STRATEGIES.TARGET_CPA &&
    selectedCampaign?.bidStrategy !== BID_STRATEGIES.MAX_VALUE;

export const isVideoBusinessModelCPM = ({ selectedCampaign }) =>
    selectedCampaign?.videoBudget?.businessModel === VIDEO_PRICING_MODEL.CPM;

export const hasSelectedCampaignAndBidModificationsAllowed = props =>
    onlySelectedCampaignColumn(props) && (isCpcBasedBidStrategy(props) || isVideoBusinessModelCPM(props));

export {
    isSiteBlockingDisabled,
    isBidStrategyPerAffiliateEditable,
    isVideoAccountReport,
    isTooltipDisabled,
    isSiteStatusEditable,
};
